import React from 'react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const role = localStorage.getItem('signup_role') || 'member';
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <h2 className="text-3xl font-bold mb-4 text-blue-500">
          Registration in Progress
        </h2>
        <p className="text-gray-300 text-lg">
          Please verify your email or check your inbox for the verification link.
        </p>
        <p className="text-gray-300 text-lg mt-2">
          Once you verify your email, you can proceed to payment.
        </p>
        <div className="space-y-2 mt-4">
            <Button
                onClick={() => navigate(`/login/${role}`)}
                variant="outline"
                className="border-gray-600 text-gray-300 hover:bg-gray-800 hover:text-white"
            >   <small>Already Verified email </small>? Back to Login
            </Button>
          
            </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
